import { motion, type HTMLMotionProps } from "motion/react";
import type { ReactNode } from "react";

export const cardMotion = {
  initial: { opacity: 0, y: 24, scale: 0.98 },
  animate: { opacity: 1, y: 0, scale: 1 },
  exit: { opacity: 0, y: -16, scale: 0.98 },
  transition: { type: "spring" as const, stiffness: 320, damping: 30 },
};

export function GlassCard({ children, strong, ...rest }: { children: ReactNode; strong?: boolean } & HTMLMotionProps<"section">) {
  return (
    <motion.section className={`glass card${strong ? " glass-strong" : ""}`} {...cardMotion} {...rest}>
      {children}
    </motion.section>
  );
}

export function Button({
  children, primary, ghost, block, icon, ...rest
}: { children: ReactNode; primary?: boolean; ghost?: boolean; block?: boolean; icon?: boolean } & HTMLMotionProps<"button">) {
  const cls = ["btn", primary && "primary", ghost && "ghost", block && "block", icon && "icon"].filter(Boolean).join(" ");
  return (
    <motion.button type="button" className={cls} whileTap={{ scale: 0.96 }} transition={{ type: "spring", stiffness: 500, damping: 30 }} {...rest}>
      {children}
    </motion.button>
  );
}
